/* eslint-disable */

import { animate, motion, useMotionValue } from "framer-motion";

import IconRaindrop from "../icon-raindrop/icon-raindrop";
import React, { useEffect } from "react";

import RaindropQRCode from "../raindrop-qr-code/raindrop-qr-code.tsx";
import { useNavigate } from "react-router-dom";
import { Color } from "../../logic/enums.ts";
import { isProductionEnvironment } from "../../services/environment.js";
import { getColorHex } from "../../logic/logic.js";

const COLOR_HEX__GREY = "#777777";

const SAUSAGE_ID__NO_VALUE = "NO_VALUE";

const CircleBackground = React.memo(
  ({ isPaused = false, accountAwardFeaturedSlug = null }) => {
    const SubCircle = ({
      tailwindBackgroundColor = "",
      backgroundColor = "#ff0",
      duration = 2,
      tailwindOpacity = "dark:opacity-60 opacity-20 ",
      xOffsetPercent = 50,
      yOffsetPercent = 0,
      isPaused = false,
    }) => {
      const MAX_PERCENT = 20;
      const tailwindSize = "dark:w-[50%] dark:h-[50%] w-[50%] h-[50%] ";

      const x = useMotionValue(`${Math.random() * 100 - 50}%`);
      const y = useMotionValue(`${Math.random() * 100 - 50}%`);

      useEffect(() => {
        if (isPaused) {
          return;
        }
        const interval = setInterval(() => {
          const newY = `${
            Math.random() * MAX_PERCENT - MAX_PERCENT / 2 + yOffsetPercent
          }%`;
          const newX = `${
            Math.random() * MAX_PERCENT - MAX_PERCENT / 2 + xOffsetPercent
          }%`;
          animate(x, newX, {
            duration: duration,
            ease: "easeInOut",
          });
          animate(y, newY, {
            duration: duration,
            ease: "easeInOut",
          });
        }, duration * 1000);

        return () => clearInterval(interval);
      }, []);

      return (
        <motion.div
          id={`sub-circle-${tailwindBackgroundColor}-${duration}`}
          key={`sub-circle-${tailwindBackgroundColor}-${duration}`}
          className={` mix-blend-lighten
           dark:blur-xl blur-sm   absolute ${tailwindSize} aspect-square rounded-full ${tailwindBackgroundColor} ${tailwindOpacity} `}
          style={{
            x: x,
            y: y,
            backgroundColor: backgroundColor,
            z: -10,
          }}
        />
      );
    };

    let circles = [];

    switch (accountAwardFeaturedSlug) {
      case "early-adopter":
        circles = [
          {
            backgroundColor: "#00A3E0",
            xOffsetPercent: -30,
          },
          {
            backgroundColor: "#A855F7",
            xOffsetPercent: 30,
          },
        ];
        break;
      case "coffee-machine":
        circles = [
          {
            backgroundColor: "#FB9548",
            xOffsetPercent: -30,
          },
          {
            backgroundColor: "#A53C12",
            xOffsetPercent: 30,
          },
        ];
        break;

      default:
        break;
    }

    return (
      <motion.div
        key="circle-background"
        className="flex flex-col items-center justify-center absolute w-full h-full -z-10   "
      >
        {circles.map((circle) => (
          <SubCircle
            backgroundColor={circle.backgroundColor}
            duration={0.9}
            xOffsetPercent={circle.xOffsetPercent}
            isPaused={isPaused}
          />
        ))}
      </motion.div>
    );
  }
);

const Badge = ({ text }) => {
  let textColor = "text-color-raindrop-minor";
  return (
    <div className="flex flex-col items-center justify-center relative w-full h-full ">
      <div className="bg-color-background-secondary p-14 rounded-full border-color-raindrop-primary border absolute" />

      <div className={`absolute font-bold whitespace-nowrap ${textColor}`}>
        {text}
      </div>

      <IconRaindrop className="absolute translate-y-8 fill-color-raindrop-primary w-4 h-4  " />
    </div>
  );
};

const CenterPiece = ({ size, badgeIndex, setBadgeIndex, isQRCode = false }) => {
  const scaler = 6;
  const pixelSize =
    {
      XXXSMALL: 50,
      XXSMALL: 100,
      XSMALL: 150,
      SMALL: 250,
      MEDIUM: 350,
      LARGE: 350,
    }[size] / scaler;

  const badges = [
    <IconRaindrop
      className="fill-color-raindrop-disabled"
      width={pixelSize}
      height={pixelSize}
    />,
    <Badge text={"Be Kind"} />,
    <div className="font-black border-y-4 py-2 text-xs text-color-raindrop-minor border-color-raindrop-minor ">
      EARLY ADOPTER
    </div>,
    <div className="font-black text-xs text-color-raindrop-minor border-color-raindrop-minor">
      <div className="text-2xl">8</div>
      <div>CONVINCED</div>
    </div>,
  ];

  if (isQRCode) {
    return <RaindropQRCode />;
  }
  return (
    <motion.div
      id={"center-piece"}
      style={{ width: pixelSize, height: pixelSize }}
      className={
        "flex flex-col items-center justify-center absolute w-full h-full "
      }
      whileHover={{ scale: 0.95 }}
      whileTap={{ scale: 0.9 }}
      onClick={() => {
        setBadgeIndex((badgeIndex + 1) % badges.length);
      }}
    >
      {badges[badgeIndex]}
    </motion.div>
  );
};

const Sausi = ({
  radius = 230,

  percent = 60,
  index = 0,
  percentTracker = 0,
  strokeWidth = 100,

  gap = 20,

  strokeColor = "#EF5FA7",
  opacity = 1,
  isSpringyTransition = true,
  showLightReflection = true,
  showBorder = true,
  scale = 1,
  color = Color.Raindrop,

  onClick = () => {},
  onHoverStart = () => {},
  onHoverEnd = () => {},
}) => {
  const [isHovered, setIsHovered] = React.useState(false);

  if (isHovered) {
    radius *= scale;
  }
  const circumference = 2 * Math.PI * radius;

  const arcLength = Math.max(
    circumference * (percent / 100) - strokeWidth - gap,
    0
  );
  const strokeDasharray = `${arcLength} ${circumference * 5}`;
  const strokeDashoffset =
    -1 * circumference * (percentTracker / 100) + strokeWidth / 2 + gap / 2;

  let transition = {
    duration: 0.2,
    type: "tween",
    stiffness: 100,
    damping: 10,
  };

  if (isSpringyTransition) {
    transition = {
      duration: 12 * (percent / 100),
      type: "spring",
      stiffness: 400,
      damping: 13,
    };
  }

  strokeColor = getColorHex(color);

  return (
    <motion.g
      id={`sausi-${index}`}
      layoutId={`sausi-${index}`}
      className={``}
      animate={{
        opacity: isHovered ? opacity * 0.6 : opacity,
      }}
    >
      <motion.circle
        onHoverStart={() => {
          setIsHovered(true);
          onHoverStart();
        }}
        onHoverEnd={() => {
          setIsHovered(false);
          onHoverEnd();
        }}
        onClick={onClick}
        className={"cursor-pointer"}
        animate={{
          cx: "50%",
          cy: "50%",
          stroke: "red",
          opacity: 0,
          strokeWidth: strokeWidth,
          r: radius,
          strokeDasharray: strokeDasharray,
          strokeDashoffset: strokeDashoffset,
          transition: transition,
          pointerEvents: "visibleStroke",
        }}
      />

      {showBorder && (
        <>
          <motion.circle
            className={"dark:stroke-white "}
            animate={{
              cx: "50%",
              cy: "50%",
              strokeWidth: strokeWidth,
              stroke: strokeColor,
              r: radius,
              strokeDasharray: strokeDasharray,
              strokeDashoffset: strokeDashoffset,
              transition: transition,
            }}
          />
          <motion.circle
            className={"dark:stroke-white stroke-black"}
            animate={{
              cx: "50%",
              cy: "50%",
              strokeWidth: strokeWidth,
              stroke: strokeColor,
              strokeOpacity: 0.2,
              r: radius,
              strokeDasharray: strokeDasharray,
              strokeDashoffset: strokeDashoffset,
              transition: transition,
            }}
          />
        </>
      )}

      <motion.circle
        animate={{
          cx: "50%",
          cy: "50%",
          stroke: strokeColor,
          strokeWidth: strokeWidth - 14,
          strokeDasharray: strokeDasharray,
          strokeDashoffset: strokeDashoffset,
          transition: transition,
          r: radius,
        }}
      />

      {showLightReflection && (
        <motion.circle
          animate={{
            cx: "50%",
            cy: "50%",
            stroke: "white",
            opacity: 0.3,
            strokeWidth: strokeWidth * 0.2,
            r: radius,
            strokeDasharray: strokeDasharray,
            strokeDashoffset: strokeDashoffset,
            transition: transition,
          }}
          style={{
            transformOrigin: "50% 50%",
            transform: "rotate(-2deg) scale(1.1)",
          }}
        />
      )}
    </motion.g>
  );
};

const Sausage = ({
  value,
  index,
  percentTracker,
  isShrunk = false,
  isSelected = false,
  isExpanded = false,
  isSpringyTransition = true,
  color = Color.Raindrop,
  onClick = () => {},
  onHoverStart = () => {},
  onHoverEnd = () => {},
}) => {
  let scale = 1;
  let opacity = 1;

  if (isShrunk) {
    scale = 0.95;
    opacity = 0.5;
  }

  if (isExpanded || isSelected) {
    scale = 1.02;
    opacity = 1;
  }

  return (
    <Sausi
      index={index}
      percent={value}
      percentTracker={percentTracker}
      scale={scale}
      opacity={opacity}
      isSpringyTransition={isSpringyTransition}
      color={color}
      onClick={onClick}
      onHoverStart={onHoverStart}
      onHoverEnd={onHoverEnd}
    />
  );
};

const TopCircle = ({
  isInitialState = false, // TODO: Initial is an unclear name.
  isFilled = false,
  isExpanded = false,
}) => {
  let opacity = 1;
  let radius = 16;
  let cy = "12%";

  let tailwindFill = "fill-transparent ";
  let tailwindStroke = "stroke-slate-400 dark:stroke-white";

  if (isFilled) {
    tailwindFill = "fill-slate-300 dark:fill-white";
  }

  if (!isInitialState) {
    opacity = 0.4;
    radius = radius * 0.8;
    cy = "16%";
  }

  if (isExpanded) {
    opacity = 0.2;
    radius = 30;
    cy = "10%";
  }

  return (
    <motion.g>
      {isFilled && (
        <motion.circle
          className={`${tailwindStroke} `}
          animate={{
            strokeWidth: "10px",
            cx: "50%",
            cy: cy,
            r: [radius, radius * 3],
            opacity: [opacity, 0],
            transition: {
              duration: 0.5,
              type: "tween",
              ease: "easeInOut",
            },
          }}
        />
      )}
      <motion.circle
        className={`${tailwindFill} ${tailwindStroke} `}
        animate={{
          strokeWidth: "10px",
          cx: "50%",
          cy: cy,
          r: radius,
          opacity: opacity,
        }}
      />
    </motion.g>
  );
};

const StartDonatingPrompt = () => {
  return (
    <div className="flex flex-col items-center absolute animate-bounce  bg-color-background-tertiary p-2 rounded-xl text-xs font-bold text-color-text-tertiary">
      <div className="flex absolute bg-color-background-tertiary w-5 h-5 rotate-45 -z-10 translate-y-2" />
      <h4>Start doing good</h4>
      {/* <h4>You're in Guest Mode</h4> */}
    </div>
  );
};

const RaindropCircle = ({
  sausageValues,
  badgeIndex = 0,
  id = "",
  style = {},
  animate = {},
  showCenterPiece = false,
  setBadgeIndex = () => {},
  rotate = 0,
  size = "MEDIUM",
  className = "",
  setMinorSelected = (sausageId, value) => {},
  doShowStartDonatingPrompt = false,
  isRaindropPlus = true,
  isPaused = false,
  isSpringyTransition = true,
  isUsingLayout = true,
  isPulsing = false,
  accountAwardFeaturedSlug = null,
}) => {
  const navigate = useNavigate();

  const isEmpty = sausageValues === undefined || sausageValues.length === 0;
  if (isEmpty) {
    sausageValues = [
      {
        id: SAUSAGE_ID__NO_VALUE,
        value: 100,
        color: COLOR_HEX__GREY,
      },
    ];
  }

  const valuesB = sausageValues.map((value) => value.value);
  const oldValues = sausageValues.map((value) => value.oldValue);
  const selectedValues = sausageValues.map((value) => value.selected);

  const pixelSize = {
    XXXSMALL: 50,
    XXSMALL: 100,
    XSMALL: 150,
    SMALL: 250,
    MEDIUM: 350,
    LARGE: 350,
  }[size];

  const isInitialState = selectedValues.every((x) => x === false || x === null);

  let percentTrackers = [];
  let percentTracker = 0;
  for (let i = 0; i < valuesB.length; i++) {
    percentTrackers.push(percentTracker);
    percentTracker += valuesB[i];
  }

  let oldPercentTrackers = [];
  let oldPercentTracker = 0;
  for (let i = 0; i < oldValues.length; i++) {
    oldPercentTrackers.push(oldPercentTracker);
    oldPercentTracker += oldValues[i];
  }

  const raindropGapPercent = 7;
  const raindropGapScaler = 1 - raindropGapPercent / 100;
  const raindropGapHalved = raindropGapPercent / 2;

  const isExpanded = badgeIndex > 0;

  let tailwindGlobalSaturation = "saturate-100";
  let tailwindGlobalOpacity = "opacity-100";

  const circleStyle = { ...style, rotate: `${rotate}deg`, width: pixelSize };

  let mainCircleTransition = "transition-all";
  if (!isSpringyTransition) {
    mainCircleTransition = "";
  }

  let layoutId: string | undefined = undefined;
  if (isUsingLayout) {
    layoutId = id + "--raindrop-circle";
  }

  if (isPulsing) {
    animate = {
      ...animate,
      scale: [0.95, 1.05],
      transition: {
        duration: 1,
        repeat: Infinity,
        repeatType: "reverse",
        ease: "easeInOut",
      },
    };
  }

  if (isPaused) {
    tailwindGlobalSaturation = "saturate-[30%]";
    tailwindGlobalOpacity = "opacity-40";
  }

  return (
    <motion.div
      id={id + "--raindrop-circle"}
      key={id + "--raindrop-circle"}
      layoutId={layoutId}
      className={`flex flex-col justify-center items-center relative pointer-events-none ${tailwindGlobalSaturation} ${tailwindGlobalOpacity}`}
    >
      <motion.svg
        id={id + "--main-circle-bit"}
        key={id + "--main-circle-bit"}
        layoutId={id + "--main-circle-bit"}
        width="100%"
        viewBox="0 0 600 600"
        className={`${className} h-full ${mainCircleTransition} z-10`}
        fill={"transparent"}
        strokeLinecap={"round"}
        style={circleStyle}
        animate={animate}
      >
        <TopCircle
          isInitialState={isInitialState}
          isFilled={isRaindropPlus}
          isExpanded={isExpanded}
        />

        <motion.g
          id={"sausage-group"}
          style={{
            transform: `rotate(-61deg)`,
            transformOrigin: "50% 50%",
          }}
        >
          {sausageValues.map((value, index) => (
            <Sausage
              key={index}
              index={index}
              value={valuesB[index] * raindropGapScaler}
              percentTracker={
                raindropGapHalved + percentTrackers[index] * raindropGapScaler
              }
              isShrunk={!isInitialState}
              isSelected={selectedValues[index]}
              isExpanded={isExpanded}
              isSpringyTransition={isSpringyTransition}
              color={value?.color}
              onClick={() => {
                console.log("onClick", value);
                if (value.organisation) {
                  navigate(`/raindrop/organisation/${value.organisation.id}`);
                } else if (value.waterfall) {
                  navigate(`/raindrop/waterfall/${value.waterfall.id}`);
                }
                // setSelected(value.id, !value.selected);
              }}
              onHoverStart={() => {
                setMinorSelected(value.id, true);
              }}
              onHoverEnd={() => {
                setMinorSelected(value.id, false);
              }}
            />
          ))}
        </motion.g>
      </motion.svg>
      {showCenterPiece && (
        <CenterPiece
          size={size}
          badgeIndex={badgeIndex}
          setBadgeIndex={setBadgeIndex}
        />
      )}
      {doShowStartDonatingPrompt && <StartDonatingPrompt />}
      <CircleBackground
        isPaused={isPaused}
        accountAwardFeaturedSlug={accountAwardFeaturedSlug}
      />
    </motion.div>
  );
};

export default RaindropCircle;
